import { render, staticRenderFns } from "./find-password.vue?vue&type=template&id=264c835a&scoped=true&"
import script from "./find-password.vue?vue&type=script&lang=ts&"
export * from "./find-password.vue?vue&type=script&lang=ts&"
import style0 from "./find-password.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./find-password.vue?vue&type=style&index=1&id=264c835a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c835a",
  null
  
)

export default component.exports